import {Row} from '../types/Row';

// We need scroll on new selected element after press arrow down or arrow up
export function createRowElementId(row: Row): string {
  return `sourcing-table-row-id--${row.sourcingVehicle?.adId}`;
}
